export * from './clearMockData';
export * from './createMockFunctions';
export * from './getMockData';
export * from './prepMockData';
export * from './setMockData';

export const shouldMockEndpoints = () => !!process.env['MOCK_ENDPOINTS'];
